import { render } from "./FireAssignmentList.vue?vue&type=template&id=3aad1891&scoped=true"
import script from "./FireAssignmentList.vue?vue&type=script&lang=ts"
export * from "./FireAssignmentList.vue?vue&type=script&lang=ts"

import "./FireAssignmentList.vue?vue&type=style&index=0&id=3aad1891&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3aad1891"

export default script